import type { Webinar } from '../types';

export type WebinarStatus = 'upcoming' | 'live' | 'replay' | 'processing' | 'expired';

/**
 * Determines the current status of a webinar based on its timing and recording availability
 */
export function useWebinarStatus(webinar: Webinar): WebinarStatus {
  const now = new Date();
  const startDate = new Date(webinar.start_date);
  const endDate = webinar.end_date ? new Date(webinar.end_date) : null;
  const validUntil = webinar.valid_until ? new Date(webinar.valid_until) : null;

  const hasStarted = now >= startDate;
  const hasEnded = endDate ? now > endDate : false;
  const hasExpired = validUntil ? now > validUntil : false;

  // Determine status based on timing and recording availability
  if (hasExpired) {
    return 'expired';
  }

  if (hasEnded) {
    // Webinar has ended - check if recording is available
    return webinar.recording_url ? 'replay' : 'processing';
  }

  if (hasStarted) {
    return 'live';
  }

  return 'upcoming';
}
